import http from "./Instance";
import {User} from "../models/User";

const urlPrefix = 'users/feed';

export const getUser = (domain: string) => {
    return http.get<User>(`${urlPrefix}/${domain}`);
}
